// prettier-ignore
export default "application/json+redirect"